import { useEffect, useState } from 'react';

export enum UC_UI_RESPONSE_STATE {
    LOADING = 'loading',
    ERROR = 'error',
    SUCCESS = 'success'
}

const MAX_RETRY = 10;
const TIMEOUT_IN_MS = 1000;

export const getUcUiResponse = () => {
    const [retry, setRetry] = useState(1);
    const [responseState, setResponseState] = useState(UC_UI_RESPONSE_STATE.LOADING);

    useEffect(() => {
        if (window.UC_UI && window.UC_UI.isInitialized()) {
            setResponseState(UC_UI_RESPONSE_STATE.SUCCESS);
            return;
        }

        setTimeout(() => {
            if (retry <= MAX_RETRY) {
                setRetry((r) => r + 1);
                return;
            }
            setResponseState(UC_UI_RESPONSE_STATE.ERROR);
        }, TIMEOUT_IN_MS);
    }, [retry]);

    return responseState;
};
